import { render, staticRenderFns } from "./SearchResultsDocument.vue?vue&type=template&id=5e793dba&scoped=true&"
import script from "./SearchResultsDocument.vue?vue&type=script&lang=js&"
export * from "./SearchResultsDocument.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsDocument.vue?vue&type=style&index=0&id=5e793dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e793dba",
  null
  
)

export default component.exports